import React, { Component } from 'react';
import { Check, Remove } from '@mui/icons-material';

class PageTreeCB extends Component {
  state={ over: false }
  render () {
    const { value, disabled, onClick, isLine } = this.props;
    const { over } = this.state;
    const disableColor = 'gray';
    const color = 'rgb(6, 75, 111)';
    const overColor = 'red';
    const backgroundColor = value ? '#E6E3ED' : 'transparent';
    return (
      <div
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          height: 16,
          width: 16,
          borderRadius: 3,
          border: `3px solid ${disabled ? disableColor : (over ? overColor : color)}`,
          backgroundColor: value ? (disabled ? disableColor : (over ? overColor : color)) : 'transparent',
          cursor: disabled ? 'default' : 'pointer',
        }}
        onClick={() => { if (!disabled)onClick(); }}
        onMouseOver={() => this.setState({ over: true })}
        onMouseOut={() => this.setState({ over: false })}
      >
        {!isLine && value && <Check style={{ color: backgroundColor }} />}
        {isLine && <Remove style={{ color: backgroundColor }} />}
      </div>
    );
  }
}
const App = (props = { value: false, disabled: false, onClick: () => {}, isLine: false }) => <PageTreeCB {...props} />;
export default App;
